export const environment = {
  production: false,
  cmsApiUrl: "https://staging.cms.kasha.co/api",
  googleClientId: "1082734459375-dtnesf1quv78cctdr79cja6k9uve02pb.apps.googleusercontent.com",
  apiUrl: "https://staging.delivery-api.kasha.co",
  loginUrl: "https://staging.cms.kasha.co/api/enterprise/login",
  auditLogUrl: "https://staging.log-api.kasha.co/collect-log",
  accessPortalUrls: {
    kenya: "https://staging.hiv-pds-accessportal.kasha.co",
    southAfrica: "https://staging.za-hiv-pds-accessportal.kasha.co",
    insights: "https://hiv-pds-insights.kasha.co/"
  },
  serviceUrls: {
    kenyaEnrollment: "https://staging.hiv-patient-enrollment-kenya.kasha.co",
    kenyaDelivery: "https://staging.delivery-form.kasha.co"
  },
  deliveryFormPageSize: 10,
  hivPDSID: 67,
  za_hivPDSID: 88,
  rw_ncdSanofiID: 105,
  rw_pdsID: 108,
  loginRedirectUrls: {
    hivPDSID: "https://staging.hiv-pds-accessportal.kasha.co",
    za_hivPDSID: "https://staging.za-hiv-pds-accessportal.kasha.co",
    rw_ncdSanofiID: 'https://staging.sanofi-ncd-accessportal.kasha.co',
    rw_pdsID: 'https://staging.pds-accessportal.kasha.rw'
  },
  checkTokenInterval: 60000
};
